import { computed } from 'vue';
import { InitialPublicOffer } from '@libs/api-reference';
import { useLiveQueryV2, CODES } from '@libs/use';

import * as API from '../requests';
import { transformInitialPublicOfferChange } from '../utils';
import { IPO_QUERY_KEYS } from '../constants';

export default function useLiveInitialPublicOffers() {
  const {
    result,
    execute: getInitialPublicOffers,
    isPending: isLoadingInitialPublicOffers,
    isRevalidating: isRevalidatingInitialPublicOffers,
    ...query
  } = useLiveQueryV2<InitialPublicOffer>({
    fetcher: API.getInitialPublicOffers,
    channel: 'global',
    unsubscribe: false,
    staleTime: 1000,
    key: IPO_QUERY_KEYS.ipo,
    onUpdate(signal) {
      const actions = {
        [CODES.InitialPublicOfferChange]: transformInitialPublicOfferChange,
      };

      if (actions[signal.code]) {
        const data = actions[signal.code](signal.data);

        if (!result.value?.data) {
          return;
        }

        const index = result.value.data.findIndex(
          (o) => o.instrumentIsin === data.instrumentIsin
        );

        if (index > -1) {
          Object.assign(result.value.data, data);
        }
      }
    },
  });

  const initialPublicOffers = computed(() => result.value?.data || []);

  const offersIsin = computed(() => {
    return initialPublicOffers.value.map((item) => item.instrumentIsin);
  });

  return {
    getInitialPublicOffers,
    initialPublicOffers,
    offersIsin,
    isLoadingInitialPublicOffers,
    isRevalidatingInitialPublicOffers,
    ...query,
  };
}
